import Image from 'next/image'
import React from 'react'

import { ChatCard } from '@/entities/ai-chat/types'

import { Button } from '@/shared/ui'

import cl from './message-cards.module.scss'

type MessageCardGroup = {
	count?: number
	uuid?: string
	cards?: ChatCard[]
}

export const MessageProductCards: React.FC<{ groups: MessageCardGroup[] }> = ({ groups }) => {
	const cards: ChatCard[] = React.useMemo(() => groups.flatMap(group => group.cards || []), [groups])

	if (!cards.length) {
		return null
	}

	const goToProduct = (productKod: string) => {
		if (!productKod) return
		window.open(`/products/productID${productKod}`, '_blank', 'noopener,noreferrer')
	}

	return (
		<div className={cl.cardsWrapper}>
			<div className={cl.cardsGrid}>
				{cards.map((card, idx) => (
					<div key={`${card.kod}-${idx}`} className={cl.card}>
						<div className={cl.imageWrapper}>
							<Image unoptimized loading="eager" src={card.image} width={100} height={100} alt={card.title} />
						</div>
						<div className={cl.cardBody}>
							<div className={cl.title} title={card.title}>
								{card.title}
							</div>
							<div className={cl.meta}>
								<span className={cl.price}>{card.price}</span>
								<span className={cl.kod}>Код: {card.kod}</span>
							</div>
							<Button size="S" onClick={() => goToProduct(card.kod)}>
								Подробнее
							</Button>
						</div>
					</div>
				))}
			</div>
		</div>
	)
}
